import {
  createApp
} from "vue";
import App from "./App.vue";
import store from "./state/store";
import * as EvaIcons from "@stefandesu/eva-icons-vue"
import {createBootstrap} from 'bootstrap-vue-next/plugins/createBootstrap'
import VueApexCharts from "vue3-apexcharts";
import vClickOutside from "click-outside-vue3"
import axios from './api/axios'
import VueAxios from 'vue-axios'
import i18n from './translations/i18n'
import VueCropper from 'vue-cropperjs';
import VueTelInput from 'vue-tel-input';
import Swal from "sweetalert2";
import VueFeather from 'vue-feather';
import Vue3Toastify from 'vue3-toastify';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'vue-tel-input/vue-tel-input.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/slider/themes/default.css';
import 'vue3-toastify/dist/index.css';
import 'simplebar/dist/simplebar.min.css';

// A masik harom ikoncsalad a sajat Sass partialjaibol jon; a unicons partial
// viszont CDN-rol toltene, ezert az npm csomagbol hozzuk be.
import '@iconscout/unicons/css/line.css';


import router from "./router";
import auth from "./auth";

import 'cropperjs/dist/cropper.css';
import "./assets/scss/app.scss";

window.Swal = Swal;

String.prototype.ucFirst = function () {
  if (!this) {
    return
  }

  if (this.length === 1) {
    return this.toUpperCase();
  } else {
    return this[0].toUpperCase() + this.substr(1);
  }
};

String.prototype.lcFirst = function () {
  if (!this) {
    return
  }

  if (this.length === 1) {
    return this.toLowerCase();
  } else {
    return this[0].toLowerCase() + this.substr(1);
  }
};

String.prototype.firstLetter = function () {
  if (!this) {
    return
  }

  return this[0];
};

String.prototype.firstLetters = function () {
  if (!this) {
    return
  }

  const words = this.split(' ').map(word => word[0]).join('')

  return words;
};

String.prototype.truncate = function (length) {
  if (!this || (this && this.length < length)) {
    return this
  }

  const text = this.substring(0, length)
  const index = text.lastIndexOf(' ')

  return text.substring(0, index) + ' ...';
};

String.prototype.rmValidation = function () {
  if (!this) {
    return
  }

  if (this.indexOf('(\\d+)') !== -1) {
    return this.replace(/\(\\d\+\)/g, '');
  } else if (this.indexOf('*') !== -1) {
    return this.replace(/\*/g, '');
  } else {
    return this;
  }
};

String.prototype.afterLast = function (character = '') {
  if (!this || !character) {
    return this;
  }

  const index = this.lastIndexOf(character) + 1;

  return this.substring(index).toLowerCase();
};

String.prototype.printDate = function (locale = 'hu-HU', options = {dateStyle: 'full', timeStyle: 'short'}) {
  if (!this) {
    return
  }

  const date = new Date(this);

  return date.toLocaleString(locale, options)
};

String.prototype.printTime = function () {
  if (!this) {
    return
  }

  const arr = this.split(':')

  if (!arr.length || arr.length === 1) {
    return this
  }

  return arr.slice(0, 2).join(':')
};

String.prototype.printCurrency = function (currency = 'HUF', locale = 'hu-HU') {
  let formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    currencyDisplay: 'narrowSymbol'
  });

  return formatter.format(this)
};

Number.prototype.printCurrency = function (currency = 'HUF', locale = 'hu-HU', notation = 'compact') {
  let formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    currencyDisplay: 'narrowSymbol',
    notation: notation
  });

  return formatter.format(this)
};

String.prototype.printMonth = function (locale = 'hu-HU', options = {month: 'long'}) {
  if (!this) {
    return
  }

  const date = new Date(this);

  return date.toLocaleString(locale, options)
};

Number.prototype.printMonth = function (locale = 'hu-HU', options = {month: 'long'}) {
  if (!this) {
    return
  }

  const year = new Date().getFullYear();

  const date = new Date(year + '-' +this);

  return date.toLocaleString(locale, options)
};

Date.prototype.formattedDate = function (withoutSeconds = false) {
  const pad = (number) => {
    return number < 10 ? '0' + String(number) : number
  }

  const time = [pad(this.getHours()), pad(this.getMinutes())];

  if (!withoutSeconds) {
    time.push(pad(this.getSeconds()));
  }


  return [this.getFullYear(), pad(this.getMonth()+1), pad(this.getDate())].join('-')
      + ' ' +
      time.join(':');

};

function startVersionChecker() {
  let currentVersion = null;

  async function checkVersion() {
    try {
      const res = await fetch('/version.json', { cache: 'no-store' });
      const { version } = await res.json();

      if (!currentVersion) {
        currentVersion = version;
      } else if (currentVersion !== version) {
        location.reload(true);
      }
    } catch (e) {
      console.error('Version check error:', e);
    }
  }

  setInterval(checkVersion, 30000);
  checkVersion();
}

if (process.env.NODE_ENV === 'production') {
  startVersionChecker();
}

if (localStorage.getItem('accessToken')) {
  store.dispatch('auth/me');
}

store.dispatch('modal/init');

const app = createApp(App)
    .use(i18n)
    .use(store)
    .use(EvaIcons)
    .use(router)
    .use(createBootstrap())
    .use(VueApexCharts)
    .use(vClickOutside)
    .use(VueAxios, axios)
    .use(auth)
    .use(VueTelInput)
    .use(Vue3Toastify)
    .directive('translate', {
      mounted: function (el, binding) {
        if (!binding.value) {
          return
        }

        let text = binding.instance.$t(binding.value)

        if (binding.modifiers.ucFirst) {
          text = text[0].toUpperCase() + text.slice(1)
        }

        if (binding.arg === 'placeholder') {
          el.placeholder = text
        } else {
          el.innerText = text
        }
      }
    })
    .component('VueCropper', VueCropper)
    .component(VueFeather.name, VueFeather);
app.config.unwrapInjectedRef = true;
app.config.errorHandler = (err, instance, info) => {
    console.error('[vue]', info, err);
};
app.mount("#app");
